<template>
    <v-dialog persistent v-model="suggestedImagesConfirmDialog" max-width="450">
      <v-card>
        <v-card-title class="subtitle-1">
          {{ pickedImages.length }} {{ lang.profile.suggestions.selected }}
        </v-card-title>

        <v-card-text v-if="suggestedActionType == 'accept'">
          <p class="subtitle-2">
            {{ lang.profile.suggestions.byAccepting }}
          </p>
          <p class="subtitle-2">{{ lang.general.areYouSure }}</p>
        </v-card-text>
        <v-card-text v-else>
          <p class="subtitle-2">
            {{ lang.profile.suggestions.byDelete }}
          </p>
          <p class="subtitle-2">{{ lang.general.areYouSure }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            elevation="0"
            small
            class="primary--text"
            @click="closeSuggestedImagesConfirmDialog()"
          >
            {{ lang.actions.cancel }}
          </v-btn>
          <v-btn
            v-if="suggestedActionType == 'accept'"
            small
            class="ml-2 btn-bg"
            elevation="0"
            @click="acceptSuggestedImages()"
          >
            {{ lang.actions.accept }}
          </v-btn>
          <v-btn
            v-else
            small
            class="ml-2 btn-bg"
            elevation="0"
            @click="deleteSuggestedImages()"
          >
            {{ lang.actions.delete }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>


<script>
export default {
  name: "SuggestedImagesConfirmDialogModal",
  data() {
    return {};
  },
  props: {
    pickedImages: {
      type: Array,
      default: function() {
        return [];
      },
    },
    suggestedImagesConfirmDialog: {
      type: Boolean,
      default: false,
    },
    suggestedActionType: {
      type: String,
      default: "accept",
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
  methods: {
    closeSuggestedImagesConfirmDialog() {
      this.$emit("closeSuggestedImagesConfirmDialog");
    },
    acceptSuggestedImages() {
      this.$emit("acceptSuggestedImages");
    },
    deleteSuggestedImages() {
      this.$emit("deleteSuggestedImages");
    },
  },
};
</script>
